import { HeaderList } from './HeaderList';
import { HttpMethod } from './HttpMethod';
import { IWebServiceRequest } from './IWebServiceRequest';

export class WebServiceRequest implements IWebServiceRequest {
    constructor(url: string, method: HttpMethod, content: string | null, headers?: HeaderList) {
        this.url = url;
        this.method = method;
        this.content = content;
        if (headers) {
            this.headers = headers;
        } else {
            this.headers = new HeaderList();
        }
    }

    url: string;
    method: HttpMethod;
    headers: HeaderList;
    content: string | null;
}